import { List, Record } from 'immutable';
import { Group } from 'web-app/react/entities/groups/model';
import Behavior from 'web-app/behaviors/behavior';
import Name, { Name as NameRecord } from '@famly/vet_common_name';
import Image, { Image as ImageRecord } from '@famly/vet_common_image';
import { OpeningHours } from 'web-app/react/modals-container/child-pickup-modal/models/shared';
import { transformContactByRelationId, } from './transform-contact-by-relation-id';
import { transformChildIdsWithoutImage } from './transform-child-ids-without-image';
class InstitutionRecord extends Record({
    image: '',
    institutionId: '',
    timezone: '',
    title: '',
    usePincodeCheckin: false,
}) {
}
class Relation extends Record({
    image: Image.default,
    name: Name.default,
    relationId: '',
    roles: List(),
}) {
}
export class PinChild extends Record({
    id: '',
    childId: '',
    image: Image.default,
    name: Name.default,
    checkedIn: false,
    pickupRelationId: '',
    pickupTime: '',
    checkinTime: null,
    goHomeWithChildId: '',
    groupId: '',
}) {
}
export class PinEmployee extends Record({
    id: '',
    employeeId: '',
    groupId: '',
    image: Image.default,
    name: Name.default,
    estimatedCheckoutTime: '',
    checkedIn: false,
    tempGroupId: '',
    checkinTime: null,
    hasImage: true,
}) {
}
export class ChildCheckinOverview extends Record({
    behaviors: List(),
    child: new PinChild(),
    institution: new InstitutionRecord(),
    openingHours: new OpeningHours(),
    relations: List(),
}) {
}
class EmployeeCheckin extends Record({
    pickupRelationId: '',
    estimatedCheckoutTime: '',
}) {
}
export const preparePinLoginResponse = (response) => {
    var _a;
    return {
        children: List(response.children.map(childCheckinOverview => {
            var _a, _b;
            return new ChildCheckinOverview({
                institution: new InstitutionRecord(childCheckinOverview.institution),
                openingHours: new OpeningHours(childCheckinOverview.openingHours),
                behaviors: List(childCheckinOverview.behaviors.map(b => new Behavior(b))),
                child: new PinChild({
                    name: new NameRecord({
                        fullName: childCheckinOverview.child.name,
                        firstName: childCheckinOverview.child.firstName,
                        lastName: childCheckinOverview.child.name.split(' ')[1],
                    }),
                    checkedIn: Boolean(childCheckinOverview.childCheckin),
                    pickupRelationId: childCheckinOverview.childCheckin && childCheckinOverview.childCheckin.pickupRelationId,
                    pickupTime: childCheckinOverview.childCheckin && childCheckinOverview.childCheckin.pickupTime,
                    checkinTime: (_b = (_a = childCheckinOverview.childCheckin) === null || _a === void 0 ? void 0 : _a.checkinTime) !== null && _b !== void 0 ? _b : null,
                    id: childCheckinOverview.child.childId,
                    image: Image.fromAPI(childCheckinOverview.child.image),
                    goHomeWithChildId: childCheckinOverview.childCheckin
                        ? childCheckinOverview.childCheckin.goHomeWithChildId
                        : '',
                    groupId: childCheckinOverview.childCheckin ? childCheckinOverview.childCheckin.groupId : '',
                }),
                relations: List(childCheckinOverview.relations.map(relation => new Relation({
                    relationId: relation.relationId,
                    roles: List(relation.roles),
                    image: Image.fromAPI(relation.image),
                    name: new NameRecord({
                        firstName: relation.name,
                    }),
                }))),
            });
        })),
        pinHolderPersonKey: (_a = response.personKey) !== null && _a !== void 0 ? _a : null,
        contactByRelationId: transformContactByRelationId(response.children),
        childIdsWithoutImage: transformChildIdsWithoutImage(response.children),
        employees: List(response.employees.map(employeeCheckinOverview => {
            var _a, _b, _c, _d, _e, _f, _g;
            return ({
                ...employeeCheckinOverview,
                employeeCheckin: employeeCheckinOverview.employeeCheckin &&
                    new EmployeeCheckin(employeeCheckinOverview.employeeCheckin),
                groups: List(employeeCheckinOverview.groups.map(group => new Group({
                    ...group,
                    image: ImageRecord({
                        large: group.image,
                        small: group.image,
                    }),
                }))),
                employee: new PinEmployee({
                    ...employeeCheckinOverview.employee,
                    image: ImageRecord({
                        small: employeeCheckinOverview.employee.image,
                        large: employeeCheckinOverview.employee.image,
                    }),
                    id: employeeCheckinOverview.employee.employeeId,
                    estimatedCheckoutTime: (_b = (_a = employeeCheckinOverview.employeeCheckin) === null || _a === void 0 ? void 0 : _a.estimatedCheckoutTime) !== null && _b !== void 0 ? _b : null,
                    checkedIn: Boolean(employeeCheckinOverview.employeeCheckin),
                    tempGroupId: (_d = (_c = employeeCheckinOverview.employeeCheckin) === null || _c === void 0 ? void 0 : _c.groupId) !== null && _d !== void 0 ? _d : '',
                    checkinTime: (_f = (_e = employeeCheckinOverview.employeeCheckin) === null || _e === void 0 ? void 0 : _e.checkinTime) !== null && _f !== void 0 ? _f : null,
                    hasImage: (_g = employeeCheckinOverview.employee.hasImage) !== null && _g !== void 0 ? _g : true,
                }),
            });
        })),
        loginId: response.loginId,
        canOpenDoor: response.canOpenDoor,
        openDoorExpiration: response.openDoorExpiration,
        openDoorHmac: response.openDoorHmac,
    };
};
